// Stored *Url fields hold an S3 key the API wrote (e.g. operator-documents/<uuid>.pdf).
// Only such a key becomes a link, on our S3 base; anything else (a full URL an
// operator typed, the legacy 'placeholder-url') gives '' so nothing opens.
const S3_KEY = /^[\w-]+(\/[\w-]+)*\/[\w-]+\.\w+$/

export const s3DocUrl = (key) => {
  const base = (process.env.REACT_APP_S3_ENDPOINT_URL || '').replace(/\/+$/, '')
  return S3_KEY.test(key || '') ? `${base}/${key}` : ''
}

// Opens a stored S3 key in a new tab; false when there is nothing safe to open.
export const openS3Doc = (key) => {
  const url = s3DocUrl(key)
  if (url) window.open(url, '_blank', 'noopener')
  return Boolean(url)
}
